import React from 'react';
import { cn } from '../../utils/cn';
import { Container } from './Container';

/**
 * Reusable page header/hero section component
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Page subtitle/description
 * @param {'primary'|'secondary'|'gradient'} props.variant - Color scheme
 * @param {string} props.className - Additional CSS classes
 */
export const PageHeader = ({
  title,
  subtitle,
  variant = 'gradient',
  className,
}) => {
  const variants = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    gradient: 'bg-gradient-to-br from-blue-900 to-blue-700',
  };

  return (
    <header
      className={cn(
        'relative py-20 md:py-32 text-white overflow-hidden',
        variants[variant],
        className
      )}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0 100 L100 0 L100 100 Z" fill="currentColor" />
        </svg>
      </div>

      <Container className="relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          {title && (
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-6 tracking-tight drop-shadow-md animate-fade-in-up">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="text-lg md:text-xl text-blue-50 max-w-2xl mx-auto leading-relaxed font-light animate-fade-in-up delay-100">
              {subtitle}
            </p>
          )}
        </div>
      </Container>
    </header>
  );
};
